import React, { useState, useEffect } from "react";
import { Box, Grid, Typography, Stack, Button, Drawer, IconButton, useTheme, useMediaQuery, Tooltip, Dialog, DialogTitle, DialogContent, DialogActions, Checkbox, FormControlLabel, Avatar, Divider, Skeleton, Chip } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import {
  getTask,
  getWorkType,
  updateTask,
  deleteTaskFile,
  getTaskBasicById,
} from "../../services/taskManagement.service";
// import AddSubTask from "../../components/TaskManagement/AddSubTask";
import AddTaskModal from "./AddTaskModal";
import dayjs from "dayjs";
import { showErrorToast as ToastError, showSuccessToast as ToastSuccess } from "../../utils/Toaster/AppToast";
import { useLocation, useNavigate } from "react-router-dom";
import Bugs_Icon from "../../assets/images/bug.png";
import Task_Icon from "../../assets/images/task.png";
import Meeting_Icon from "../../assets/images/alarm-clock.png";
import Extra_Icon from "../../assets/images/plus.png";
import Testing_Icon from "../../assets/images/clock-check.png";
import Designing_Icon from "../../assets/images/mynaui_filter.png";
import Deployment_Icon from "../../assets/images/PageUnderConstruction.png";
import { jwtDecode } from "jwt-decode";
import { useAuth } from "../../context/AuthProvider";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";
import relativeTime from "dayjs/plugin/relativeTime";
import {
  PRIORITY,
  STATUS,
  TASK_STATUS,
  ISSUETYPE,
  VERIFY_STATUS,
} from "../../constant/constant";
import { getProjectParentTask } from "../../services/parentTask";
// Import Date and Time pickers
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";

import {
  getPriorityLabel,
  getStatusLabel,
  getIssueTypeLabel,
  getVerifyStatusLabel,
} from "./utils/helpers";


import { FiMessageSquare, FiClock, FiPaperclip, FiActivity, FiRefreshCw, FiArchive, FiTrash2, FiRotateCcw } from "react-icons/fi";
import TitleSection from "./components/TitleSection";
import DescriptionSection from "./components/DescriptionSection";
import Attachments from "./components/Attachments";
import DetailsPanel from "./components/DetailsPanel";
import RecurringCard from "./components/RecurringCard";
import RecurringSpawnsTab from "./components/RecurringSpawnsTab";
import RecurringTemplateMain from "../RecurringTask/RecurringTemplateMain";
import { getRecurringTemplateById } from "../../services/recurringTemplate.service";
import { getChildTasks, acknowledgeTodoTask, requestReworkTodoTask, archiveTodoTask, deleteTodoTask, restoreTodoTask } from "../../services/todoTask.service";
import WorkLogs from "./components/WorkLog";
import Comments from "./components/Comments";
import Activity from "./components/Activity";

dayjs.extend(relativeTime);
dayjs.extend(utc);
dayjs.extend(timezone);

const TaskDetails = (props) => {
  const location = useLocation();
  const { accessToken } = useAuth();
  const queryParams = new URLSearchParams(location.search);
  const taskId = queryParams.get("taskId");
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));
  const [selectedData, setSelectedData] = useState({});
  const [isDetailsOpen, setIsDetailsOpen] = useState(!isMobile); // Default based on device

  useEffect(() => {
    setIsDetailsOpen(!isMobile);
  }, [isMobile]);
  const [loading, setLoading] = useState(false);
  const [fileUploading, setFileUploading] = useState(false);

  const [isClientView, setIsClientView] = useState(false);
  const [workTypeData, setWorkTypeData] = useState([]);
  const [parentTasks, setParentTasks] = useState([]);
  const [selectedParentTask, setSelectedParentTask] = useState(null);
  const [isAdmin, setIsAdmin] = useState(false);
  const [userId, setUserId] = useState(null);
  const [templateDrawerOpen, setTemplateDrawerOpen] = useState(false);
  const [templateDrawerData, setTemplateDrawerData] = useState(null);
  const [templatePrefill, setTemplatePrefill] = useState(null);
  const [templateAccessDenied, setTemplateAccessDenied] = useState(false);

  const handleOpenTemplate = async () => {
    const templateId = selectedData?.recurringTemplateId;
    if (!templateId) { handleCreateTemplate(); return; }
    // The creator check that used to live here was client-side only — the
    // endpoint answered anyone. It now 404s for a viewer who may not see the
    // template, so the refusal is the server's and this just renders it.
    try {
      const res = await getRecurringTemplateById(templateId);
      if (res?.error === false && res?.data) {
        setTemplateAccessDenied(false);
        setTemplateDrawerData(res.data);
      } else {
        setTemplateAccessDenied(true);
        return;
      }
    } catch {
      // A 404 rejects here. Returning is what matters: setTemplateDrawerOpen
      // sat AFTER the try/catch, so a failure fell through and opened the
      // drawer in CREATE mode (initialView keys off templateDrawerData).
      setTemplateAccessDenied(true);
      return;
    }
    setTemplateDrawerOpen(true);
  };

  const handleCreateTemplate = () => {
    setTemplateDrawerData(null);
    // This payload is hand-picked, so every field the recurring form reads has
    // to be listed here — anything omitted silently arrives as undefined and
    // the corresponding field opens blank.
    setTemplatePrefill(selectedData ? {
      title: selectedData.title || "",
      description: selectedData.description || "",
      priority: selectedData.priority,
      status: selectedData.status,
      // Carry the whole roster; `assignee`/`assigneeName` stay as the legacy
      // fallback for tasks that predate assignees[].
      assignees: selectedData.assignees || [],
      assignee: selectedData.assignee || null,
      assigneeName: selectedData.assigneeName || "",
      support: selectedData.support || null,
      supportName: selectedData.supportName || "",
      acknowledgedBy: selectedData.acknowledgedBy || null,
      acknowledgedByName: selectedData.acknowledgedByName || "",
    } : null);
    setTemplateDrawerOpen(true);
  };



  // Linked Testing Tasks State
  const [openLinkDialog, setOpenLinkDialog] = useState(false);
  const [activeTab, setActiveTab] = useState("comments"); // comments | worklog | activity
  const [childTaskCount, setChildTaskCount] = useState(0);
  const [testingTasksList, setTestingTasksList] = useState([]);
  const [selectedLinkIds, setSelectedLinkIds] = useState([]);
  const [isFetchingTasks, setIsFetchingTasks] = useState(false);

  const fetchTestingTasks = async () => {
    setIsFetchingTasks(true);
    try {
      const res = await getTask({ type: ISSUETYPE.TESTING, project: selectedData?.project });
      if (res && res.data) {
        let allTasks = [];
        const taskGroups = res.data;
        // Handle both grouped and flat API responses
        if (Array.isArray(taskGroups)) {
          allTasks = taskGroups;
        } else {
          Object.values(taskGroups).forEach(group => {
            if (Array.isArray(group)) allTasks = [...allTasks, ...group];
          });
        }

        // Filter out the current task itself
        allTasks = allTasks.filter(t => t._id !== selectedData._id);
        setTestingTasksList(allTasks);
      }
    } catch (error) {
      console.error("Error fetching testing tasks:", error);
      ToastError("Failed to fetch testing tasks");
    } finally {
      setIsFetchingTasks(false);
    }
  };

  const handleOpenLinkDialog = () => {
    fetchTestingTasks();
    const currentLinkedIds = selectedData?.testingTasks?.map(t => t._id) || [];
    setSelectedLinkIds(currentLinkedIds);
    setOpenLinkDialog(true);
  };

  const handleCloseLinkDialog = () => {
    setOpenLinkDialog(false);
  };

  const handleToggleTaskSelection = (taskId) => {
    setSelectedLinkIds(prevIds => {
      if (prevIds.includes(taskId)) {
        return prevIds.filter(id => id !== taskId);
      } else {
        return [...prevIds, taskId];
      }
    });
  };

  const handleSaveLinks = async () => {
    try {
      const payload = {
        testingTasks: selectedLinkIds
      };

      const formData = new FormData();
      formData.append("bodyData", JSON.stringify(payload));

      const res = await updateTask(selectedData._id, formData);
      if (res.error === false) {
        ToastSuccess("Linked tasks updated successfully");
        GetSeparateTaskId(selectedData._id, true);
        handleCloseLinkDialog();
      } else {
        ToastError(res?.message || "Failed to update links");
      }
    } catch (error) {
      console.error("Error updating links:", error);
      ToastError("An error occurred while linking tasks");
    }
  };

  const handleUnlinkTask = async (taskId, e) => {
    e.stopPropagation(); // Prevent opening task details
    // Confirm delete if needed? For now direct unlink for speed as per "Quick remove"
    try {
      const currentLinkedIds = selectedData?.testingTasks?.map(t => t._id) || [];
      const newLinkedIds = currentLinkedIds.filter(id => id !== taskId);

      const payload = {
        testingTasks: newLinkedIds
      };

      const res = await updateTask(selectedData._id, payload);
      if (res.error === false) {
        ToastSuccess("Task unlinked successfully");
        GetSeparateTaskId(selectedData._id, true);
      } else {
        ToastError(res?.message || "Failed to unlink task");
      }
    } catch (error) {
      console.error("Error unlinking task:", error);
      ToastError("An error occurred while unlinking task");
    }
  };

  const navigate = useNavigate();

  const filteredStatus = location.state?.filteredStatus || null;
  const filteredMonth = location.state?.selectedMonth || null;
  const filteredYear = location.state?.selectedYear || null;
  const fromClient = location.state?.fromClient || false;
  const isOverAllAdmin = location.state?.isOverAllAdmin || false;
  useEffect(() => {
    const getUserIdFromToken = () => {
      if (!accessToken) return null;
      try {
        const decoded = jwtDecode(accessToken);
        const role = decoded.role;
        const isOverAllAdmin = localStorage.getItem("isOverAllAdmin") === "true";
        const adminStatus = role === 1 || role === 4 || role === 5 || isOverAllAdmin;
        setIsAdmin(adminStatus);
        return decoded.id;
      } catch (error) {
        console.error("Invalid token", error);
        return null;
      }
    };

    setUserId(getUserIdFromToken());
  }, [accessToken]);

  const GetSeparateTaskId = async (taskId, silent = false) => {
    try {
      if (!silent) setLoading(true);
      const res = await getTaskBasicById(taskId);
      if (res?.error) {
        if (!silent) {
          ToastError(res?.message || "Failed to load task details");
          setLoading(false);
        }
        return;
      }
      const configData = res?.data;
      if (!configData) {
        if (!silent) {
          ToastError("Task data is empty");
          setLoading(false);
        }
        return;
      }
      setSelectedData(configData);
      setIsClientView(configData?.isclientView || false);
      setSelectedParentTask(configData?.parentTask || null);
      if (!silent) setLoading(false);

      // Fetch child task count to decide whether to show the Recurring tab
      if (configData?._id && configData?.isRecurring) {
        getChildTasks(configData._id)
          .then((r) => { if (r?.error === false) setChildTaskCount(r.data?.length || 0); })
          .catch(() => { });
      } else {
        setChildTaskCount(0);
      }
    } catch (error) {
      console.log("Error in GetSeparateTaskId:", error);
      if (!silent) setLoading(false);
    }
  };


  useEffect(() => {
    if (taskId) {
      GetSeparateTaskId(taskId);
    }
  }, [taskId]);

  const updateTaskData = async (payload, { silent = false } = {}) => {
    const formData = new FormData();
    formData.append(
      "bodyData",
      JSON.stringify({
        ...payload,
        assignedToId: userId,
      })
    );

    try {
      await updateTask(selectedData._id, formData);
      GetSeparateTaskId(selectedData._id, true);
      ToastSuccess("Updated successfully");
      return { ok: true };
    } catch (error) {
      console.error(error);
      const errorMessage =
        error?.data?.message ||
        error?.message ||
        "Failed to update. Please try again.";
      if (!silent) ToastError(errorMessage);
      return { ok: false, message: errorMessage };
    }
  };

  // Fetch Parent Tasks
  const fetchParentTasks = async () => {
    try {
      if (selectedData?.project) {
        const res = await getProjectParentTask(selectedData?.project);
        const configData = res?.data?.data?.map((task) => {
          const projectTypeName = task.projectType?.name
            ? ` (${task.projectType.name})`
            : "";
          const title = task.title ? ` - ${task.title}` : "";
          return {
            ...task,
            label: (task.code || "Untitled Task") + title + projectTypeName,
          };
        });
        setParentTasks(configData || []);
      } else {
        setParentTasks([]);
      }
    } catch (error) {
      console.error("Error fetching parent tasks:", error);
      ToastError("Failed to load parent tasks");
    }
  };

  useEffect(() => {
    if (selectedData?.project) fetchParentTasks();
  }, [selectedData]);

  // Handle Parent Task Change
  const handleParentTaskChange = async (event, task) => {
    if (!task || task._id === selectedData?.parentTask) return;
    try {
      await updateTaskData({ parentTask: task._id });
      setSelectedParentTask(task);
    } catch (error) {
      console.error("Error updating parent task:", error);
      ToastError("Failed to update parent task");
    }
  };

  // Remove Parent Task
  const handleRemoveParentTask = async () => {
    try {
      await updateTaskData({ parentTask: null });
      setSelectedParentTask(null);
      ToastSuccess("Parent task removed successfully");
    } catch (error) {
      console.error("Error removing parent task:", error);
      ToastError("Failed to remove parent task");
    }
  };

  // Get Parent Task Name by ID
  const getParentTaskName = (parentTaskId) => {
    if (!parentTaskId) return "No Parent Task";
    const parentTask = parentTasks.find((task) => task._id === parentTaskId);
    return parentTask ? parentTask?.label : "";
  };

  const handleNavigate = () => {
    navigate(-1);
  };

  // ── Archive / Delete / Restore ───────────────────────────────────────────────
  // Same business rule as the board card menu (TodoTaskDragSection): only an
  // admin or the task creator may archive, delete or restore a task.
  const [lifecycleDialog, setLifecycleDialog] = useState({ open: false, message: "", confirmLabel: "OK", danger: false, onConfirm: null });
  const [lifecycleBusy, setLifecycleBusy] = useState(false);
  const [activityRefreshKey, setActivityRefreshKey] = useState(0);

  const closeLifecycleDialog = () => setLifecycleDialog({ open: false, message: "", confirmLabel: "OK", danger: false, onConfirm: null });

  const askLifecycle = (message, confirmLabel, danger, onConfirm) =>
    setLifecycleDialog({ open: true, message, confirmLabel, danger, onConfirm });

  const runLifecycle = async (action, successMessage) => {
    setLifecycleBusy(true);
    try {
      const res = await action(taskId);
      if (res?.error) {
        ToastError(res?.message || "Action failed. Please try again.");
        return false;
      }
      ToastSuccess(res?.message || successMessage);
      return true;
    } catch (error) {
      ToastError(error?.message || "Action failed. Please try again.");
      return false;
    } finally {
      setLifecycleBusy(false);
    }
  };

  const handleArchiveTask = () => {
    askLifecycle(`Archive task #${selectedData?.taskNo || taskId}?`, "Archive", false, async () => {
      // Archived tasks leave the board, so send the user back where they came from.
      if (await runLifecycle(archiveTodoTask, "Task archived successfully")) handleNavigate();
    });
  };

  const handleRestoreTask = () => {
    askLifecycle(`Restore task #${selectedData?.taskNo || taskId}?`, "Restore", false, async () => {
      if (await runLifecycle(restoreTodoTask, "Task restored successfully")) {
        GetSeparateTaskId(taskId, true);
        // Remount Activity so the RESTORED row shows without leaving the tab.
        setActivityRefreshKey((k) => k + 1);
      }
    });
  };

  const handleDeleteTask = () => {
    askLifecycle(`Delete task #${selectedData?.taskNo || taskId}?`, "Delete", true, async () => {
      if (await runLifecycle(deleteTodoTask, "Task deleted successfully")) handleNavigate();
    });
  };

  const handlePriorityChange = async (event, value) => {
    if (value.value === selectedData?.priority) return;
    await updateTaskData({ priority: value.value });
  };

  const handleVerifyStatusChange = async (event, value) => {
    if (value.value === selectedData?.verifyStatus) return;
    await updateTaskData({ verifyStatus: value.value, status: STATUS.TODO });
  };

  const handleClientVerifyStatusChange = async (event, value) => {
    if (value.value === selectedData?.clientVerifyStatus) return;
    const payload = { clientVerifyStatus: value.value };
    if (value.value !== VERIFY_STATUS.REOPEN) {
      payload.clientVerified = true;
    } else {
      payload.status = STATUS.TODO;
    }
    await updateTaskData(payload);
  };

  const handletypeChange = async (event, value) => {
    if (value.value === selectedData?.issueType) return;
    await updateTaskData({ issueType: value.value });
  };

  const handleStatusChange = async (event, value) => {
    if (!value || value.value === selectedData?.status) return;
    const creatorId = selectedData?.assignedBy?._id || selectedData?.assignedBy;
    const canControlRestricted = isAdmin || (userId && creatorId && String(userId) === String(creatorId));
    const RESTRICTED = [TASK_STATUS.HOLD, TASK_STATUS.DUPLICATE];
    if (RESTRICTED.includes(value.value) || RESTRICTED.includes(selectedData?.status)) {
      if (!canControlRestricted) {
        ToastError("Only the task creator or admin can set Hold or Duplicate status");
        return;
      }
    }
    await updateTaskData({ status: value.value, StatusChange: true });
  };

  const handleAssignedToChange = async (event, value) => {
    if (value._id === selectedData?.assignee) return;
    await updateTaskData({ assignee: value._id, taskId });
  };

  // updateTaskData serialises its payload into the `bodyData` JSON blob, so an
  // array goes over the wire natively — no encoding change needed here.
  const handleAssigneesChange = async (ids) => {
    await updateTaskData({ assignees: ids, taskId });
  };

  const handlePrivateAssigneesChange = async (value) => {
    await updateTaskData({ privateAssignees: value });
  };

  const handleSupportChange = async (event, value) => {
    if (value._id === selectedData?.support) return;
    await updateTaskData({ support: value._id });
  };

  const handleAcknowledgedByChange = async (event, value) => {
    const newId = value?._id || null;
    if (newId === selectedData?.acknowledgedBy) return;
    await updateTaskData({ acknowledgedBy: newId });
  };

  const handleAcknowledge = async () => {
    try {
      const res = await acknowledgeTodoTask(taskId);
      if (res?.error === false) {
        ToastSuccess("Task acknowledged successfully");
        GetSeparateTaskId(taskId, true);
      } else {
        ToastError(res?.message || "Failed to acknowledge task");
      }
    } catch {
      ToastError("Failed to acknowledge task");
    }
  };

  const handleRequestRework = async (note) => {
    try {
      const res = await requestReworkTodoTask(taskId, note);
      if (res?.error === false) {
        ToastSuccess("Rework requested successfully");
        GetSeparateTaskId(taskId, true);
      } else {
        ToastError(res?.message || "Failed to request rework");
      }
    } catch {
      ToastError("Failed to request rework");
    }
  };

  const handleDeleteFile = async (file) => {
    try {
      const formData = new FormData();
      formData.append(
        "bodyData",
        JSON.stringify({
          $pull: { file: { location: file.location } },
          _removedFile: { fileName: file.fileName, location: file.location },
        })
      );
      const res = await updateTask(selectedData._id, formData);
      ToastSuccess(res?.message || "File deleted successfully");
      GetSeparateTaskId(selectedData._id, true);
    } catch (error) {
      console.error(error);
      ToastError(error?.message || "Failed to delete file. Please try again.");
    }
  };


  const handleClientViewChange = async (e) => {
    const newIsClientView = e.target.checked;
    setIsClientView(newIsClientView);
    await updateTaskData({ isclientView: newIsClientView });
  };

  const handleActualDeadlineDateChange = async (event, reason) => {
    const newDate = event.target.value;
    const existingDate = selectedData?.actualDeadlineDate
      ? new Date(selectedData.actualDeadlineDate).toISOString().split("T")[0]
      : "";
    if (newDate === existingDate) return;
    const payload = { actualDeadlineDate: newDate };
    if (reason) payload.deadlineChangeReason = reason;
    await updateTaskData(payload);
  };

  const handleAllowDeadlineModificationChange = async (value) => {
    await updateTaskData({ allowDeadlineModification: value });
  };

  const handleClientDeadlineDateChange = async (event) => {
    const newDate = event.target.value;
    const existingDate = selectedData?.clientDeadlineDate
      ? new Date(selectedData.clientDeadlineDate).toISOString().split("T")[0]
      : "";
    if (newDate === existingDate) return;
    await updateTaskData({ clientDeadlineDate: newDate });
  };

  const GetWorkTypeData = async () => {
    try {
      const res = await getWorkType();
      const configData = res?.data?.data?.map((e) => {
        return {
          ...e,
          label: e.workType,
        };
      });
      setWorkTypeData(configData);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    GetWorkTypeData();
  }, []);

  const addFile = async (id, files) => {
    if (!files) return;
    setFileUploading(true);
    const formData = new FormData();
    formData.append("file", files);
    formData.append("bodyData", JSON.stringify({ assignedToId: userId }));
    try {
      const res = await updateTask(id, formData);
      ToastSuccess(res.message);
      GetSeparateTaskId(id, true);
    } catch (error) {
      console.error(error);
      ToastError("File Not Uploaded");
    } finally {
      setFileUploading(false);
    }
  };


  useEffect(() => {
    if (taskId) {

    }
  }, [taskId]);






  // Acknowledge (5) is set only via the acknowledgment flow — read-only here.
  // Rework Required (6) lets the assignee move back to In Progress to restart work.
  const currentStatus = selectedData?.status;
  const creatorIdForStatus = selectedData?.assignedBy?._id || selectedData?.assignedBy;
  const canControlRestricted = isAdmin || (userId && creatorIdForStatus && String(userId) === String(creatorIdForStatus));

  // Board-card parity: admin or creator may archive/delete/restore.
  const canManageTask = canControlRestricted;
  const isArchivedTask = Boolean(selectedData?.isArchived);

  const filteredStatusOptions = currentStatus === TASK_STATUS.ACKNOWLEDGE
    ? canControlRestricted
      ? [
          { label: "To Do",           value: TASK_STATUS.TODO },
          { label: "In Progress",     value: TASK_STATUS.INPROGRESS },
          { label: "Completed",       value: TASK_STATUS.COMPLETED },
          { label: "Hold",            value: TASK_STATUS.HOLD },
          { label: "Duplicate",       value: TASK_STATUS.DUPLICATE },
        ]
      : []  // locked for non-creator/non-admin
    : (currentStatus === TASK_STATUS.HOLD || currentStatus === TASK_STATUS.DUPLICATE)
      ? canControlRestricted
        ? [
            { label: "To Do",       value: TASK_STATUS.TODO },
            { label: "In Progress", value: TASK_STATUS.INPROGRESS },
            { label: "Completed",   value: TASK_STATUS.COMPLETED },
            { label: "Hold",        value: TASK_STATUS.HOLD },
            { label: "Duplicate",   value: TASK_STATUS.DUPLICATE },
          ]
        : []  // locked — non-creator/non-admin cannot change
      : currentStatus === TASK_STATUS.REWORK_REQUIRED
        ? [
            { label: "To Do",       value: TASK_STATUS.TODO },
            { label: "In Progress", value: TASK_STATUS.INPROGRESS },
          ]
        : [
            { label: "To Do",       value: TASK_STATUS.TODO },
            { label: "In Progress", value: TASK_STATUS.INPROGRESS },
            { label: "Completed",   value: TASK_STATUS.COMPLETED },
            ...(canControlRestricted
              ? [
                  { label: "Hold",      value: TASK_STATUS.HOLD },
                  { label: "Duplicate", value: TASK_STATUS.DUPLICATE },
                ]
              : []
            ),
          ];

  const priorityOption = [
    { label: "Low", value: PRIORITY.LOW },
    { label: "Medium", value: PRIORITY.MEDIUM },
    { label: "High", value: PRIORITY.HIGH },
  ];
  const QAVerifyOption = [{ label: "Reopen", value: VERIFY_STATUS.REOPEN }];
  const clientVerifyOption = [
    { label: "Completed", value: VERIFY_STATUS.COMPLETED },
    { label: "Reopen", value: VERIFY_STATUS.REOPEN },
  ];

  // All type options (full list)
  const allTypeOptions = [
    {
      label: "Task",
      value: ISSUETYPE.TASK,
      icon: (
        <img
          src={Task_Icon}
          alt="Task_Icon"
          style={{
            height: "20px",
            width: "20px",
          }}
        />
      ),
    },
    {
      label: "Bugs",
      value: ISSUETYPE.BUG,
      icon: (
        <img
          src={Bugs_Icon}
          alt="Bugs_Icon"
          style={{
            height: "20px",
            width: "20px",
          }}
        />
      ),
    },
    {
      label: "Meeting",
      value: ISSUETYPE.MEETING,
      icon: (
        <img
          src={Meeting_Icon}
          alt="Meeting_Icon"
          style={{
            height: "20px",
            width: "20px",
          }}
        />
      ),
    },
    {
      label: "Testing",
      value: ISSUETYPE.TESTING,
      icon: (
        <img
          src={Testing_Icon}
          alt="Testing_Icon"
          style={{
            height: "20px",
            width: "20px",
          }}
        />
      ),
    },
    {
      label: "Designing",
      value: ISSUETYPE.DESIGNING,
      icon: (
        <img
          src={Designing_Icon}
          alt="Designing_Icon"
          style={{
            height: "20px",
            width: "20px",
          }}
        />
      ),
    },
    {
      label: "Others",
      value: ISSUETYPE.OTHERS,
      icon: (
        <img
          src={Extra_Icon}
          alt="Others_Icon"
          style={{
            height: "20px",
            width: "20px",
          }}
        />
      ),
    },
    {
      label: "Deployment",
      value: ISSUETYPE.DEPLOYMENT,
      icon: (
        <img
          src={Deployment_Icon}
          alt="Deployment_Icon"
          style={{
            height: "20px",
            width: "20px",
          }}
        />
      ),
    },
  ];

  // Filter type options based on current issue type
  // If current is Bug, show all (but dropdown will be disabled)
  // If current is not Bug, exclude Bugs from options
  const isBugType = selectedData?.issueType === ISSUETYPE.BUG;
  const typeOption = isBugType
    ? allTypeOptions
    : allTypeOptions.filter((opt) => opt.value !== ISSUETYPE.BUG);

  // Helper function to get current display values
  const getCurrentPriorityLabel = () => {
    return getPriorityLabel(selectedData?.priority);
  };

  const getCurrentStatusLabel = () => {
    return getStatusLabel(selectedData?.status) || "To Do";
  };

  const getCurrentIssueTypeLabel = () => {
    return getIssueTypeLabel(selectedData?.issueType);
  };

  const getCurrentVerifyStatusLabel = () => {
    return getVerifyStatusLabel(
      fromClient === true
        ? selectedData?.clientVerifyStatus
        : selectedData?.verifyStatus
    );
  };

  // ── Design tokens (Linear / Notion / Jira inspired) ──────────────────────────
  const UI = {
    bg: "#FFFFFF",
    surface: "#F8FAFC",
    page: "#F1F5F9",
    border: "#CBD5E1",
    borderLight: "#E2E8F0",
    text: "#0F172A",
    textSub: "#334155",
    textMuted: "#64748B",
    accent: "#0D9488",
    accentSoft: "#CCFBF1",
  };

  const SectionHeader = ({ children, count, action }) => (
    <Stack
      direction="row"
      alignItems="center"
      justifyContent="space-between"
      sx={{ mb: 1.2 }}
    >
      <Stack direction="row" alignItems="center" spacing={1}>
        <Typography
          sx={{
            fontSize: "11px",
            fontWeight: 700,
            color: UI.textMuted,
            letterSpacing: "0.08em",
            textTransform: "uppercase",
          }}
        >
          {children}
        </Typography>
        {typeof count === "number" && (
          <Chip
            label={count}
            size="small"
            sx={{
              height: 18,
              fontSize: "10.5px",
              fontWeight: 700,
              bgcolor: UI.borderLight,
              color: UI.textSub,
              "& .MuiChip-label": { px: 0.8 },
            }}
          />
        )}
      </Stack>
      {action}
    </Stack>
  );

  return (
    <div className="addRenderingContainer" style={{ height: "100%", display: "flex", flexDirection: "column", overflow: "hidden" }}>
      {/* ── Top header: breadcrumb · title · actions ─────────────────────────── */}
      <Box
        className="addContainerHeader1"
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          px: 2.5,
          py: 1.2,
          borderBottom: `1px solid ${UI.border}`,
          background: UI.bg,
          flexShrink: 0,
          position: "sticky",
          top: 0,
          zIndex: 10,
        }}
      >
        <Stack direction="row" spacing={1.5} alignItems="center" sx={{ minWidth: 0, flex: 1 }}>
          {selectedData?.taskNo && (
            <Chip
              label={selectedData.taskNo}
              size="small"
              sx={{
                height: 22,
                fontSize: "11px",
                fontWeight: 700,
                bgcolor: UI.accentSoft,
                color: UI.accent,
                border: `1px solid ${UI.accent}30`,
                "& .MuiChip-label": { px: 1 },
              }}
            />
          )}
          <Box sx={{ flex: 1, minWidth: 0 }}>
            <TitleSection
              initialTitle={selectedData?.title || ""}
              onSave={updateTaskData}
              selectedData={selectedData}
              sx={{ fontSize: "15px", fontWeight: 600 }}
            />
          </Box>
        </Stack>
        <Stack direction="row" spacing={0.5} alignItems="center">
          {canManageTask && selectedData?._id && (
            <>
              {isArchivedTask ? (
                <Tooltip title="Restore task">
                  <span>
                    <IconButton
                      size="small"
                      disabled={lifecycleBusy}
                      onClick={handleRestoreTask}
                      sx={{
                        color: UI.accent,
                        borderRadius: "8px",
                        "&:hover": { background: UI.accentSoft },
                      }}
                    >
                      <FiRotateCcw size={16} />
                    </IconButton>
                  </span>
                </Tooltip>
              ) : (
                <Tooltip title="Archive task">
                  <span>
                    <IconButton
                      size="small"
                      disabled={lifecycleBusy}
                      onClick={handleArchiveTask}
                      sx={{
                        color: "#D97706",
                        borderRadius: "8px",
                        "&:hover": { background: "#FFFBEB" },
                      }}
                    >
                      <FiArchive size={16} />
                    </IconButton>
                  </span>
                </Tooltip>
              )}
              <Tooltip title="Delete task">
                <span>
                  <IconButton
                    size="small"
                    disabled={lifecycleBusy}
                    onClick={handleDeleteTask}
                    sx={{
                      color: "#DC2626",
                      borderRadius: "8px",
                      "&:hover": { background: "#FEF2F2" },
                    }}
                  >
                    <FiTrash2 size={16} />
                  </IconButton>
                </span>
              </Tooltip>
              <Divider orientation="vertical" flexItem sx={{ mx: 0.3, my: 0.6, borderColor: UI.borderLight }} />
            </>
          )}
          <Tooltip title={isDetailsOpen ? "Hide details" : "Show details"}>
            <IconButton
              size="small"
              onClick={() => setIsDetailsOpen(!isDetailsOpen)}
              sx={{
                color: isDetailsOpen ? UI.accent : UI.textSub,
                background: isDetailsOpen ? UI.accentSoft : "transparent",
                borderRadius: "8px",
                "&:hover": { background: UI.accentSoft, color: UI.accent },
              }}
            >
              <InfoOutlinedIcon sx={{ fontSize: 18 }} />
            </IconButton>
          </Tooltip>
          <Tooltip title="Close">
            <IconButton
              size="small"
              onClick={handleNavigate}
              sx={{
                color: UI.textSub,
                borderRadius: "8px",
                "&:hover": { background: UI.borderLight, color: UI.text },
              }}
            >
              <CloseIcon sx={{ fontSize: 18 }} />
            </IconButton>
          </Tooltip>
        </Stack>
      </Box>

      <Box className="addContainerCenter" sx={{ flex: 1, overflow: "hidden", minHeight: 0, display: "flex", flexDirection: "column" }}>
        <Grid container sx={{ height: "100%", flexWrap: "nowrap" }}>
          <Grid
            item
            xs={12}
            md={isDetailsOpen ? 8 : 12}
            sx={{ padding: 1, transition: "all 0.3s ease", height: "100%", overflowY: "auto", overflowX: "hidden", scrollbarWidth: "none", "&::-webkit-scrollbar": { display: "none" } }}
          >
            {loading ? (
              <Box sx={{ p: 2 }}>
                <Stack spacing={3}>
                  <Box>
                    <Skeleton variant="text" sx={{ fontSize: '2rem', width: '60%' }} />
                    <Skeleton variant="text" sx={{ fontSize: '1rem', width: '40%' }} />
                  </Box>
                  <Box sx={{ mt: 2 }}>
                    <Stack direction="row" spacing={1} mb={1}>
                      <Skeleton variant="circular" width={24} height={24} />
                      <Skeleton variant="text" width={100} />
                    </Stack>
                    <Skeleton variant="rectangular" height={150} sx={{ borderRadius: '8px' }} />
                  </Box>
                  <Box>
                    <Skeleton variant="rectangular" height={100} sx={{ borderRadius: '8px' }} />
                  </Box>
                  <Box>
                    <Skeleton variant="rectangular" height={200} sx={{ borderRadius: '8px' }} />
                  </Box>
                </Stack>
              </Box>
            ) : selectedData?._id ? (
              <Box sx={{ px: { xs: 1.5, md: 3 }, py: 2 }}>

                {/* ── Description ──────────────────────────────────────────── */}
                <Box sx={{ mb: 3 }}>
                  <SectionHeader>Description</SectionHeader>
                  <DescriptionSection
                    initialDescription={selectedData?.description || ""}
                    onSave={updateTaskData}
                  />
                </Box>

                <Divider sx={{ borderColor: UI.borderLight, my: 2 }} />

                {/* ── Tabs: Comments | Work Log | Attachments | Activity ───── */}
                <Box sx={{ mt: 2 }}>
                  {/* ── Segmented pill tab bar ── */}
                  {(() => {
                    const tabs = [
                      { value: "comments", label: "Comments", icon: FiMessageSquare, count: null },
                      { value: "worklog", label: "Work Log", icon: FiClock, count: selectedData?.workLog?.length ?? 0 },
                      { value: "attachments", label: "Attachments", icon: FiPaperclip, count: selectedData?.file?.length ?? 0 },
                      { value: "activity", label: "Activity", icon: FiActivity, count: null },
                      ...(childTaskCount > 0
                        ? [{ value: "recurring", label: "Recurring", icon: FiRefreshCw, count: childTaskCount }]
                        : []),
                    ];
                    return (
                      <Box
                        sx={{
                          display: "inline-flex",
                          alignItems: "center",
                          gap: "4px",
                          background: "#EEF2F7",
                          borderRadius: "12px",
                          p: "4px",
                          mb: 2.5,
                          width: "100%",
                        }}
                      >
                        {tabs.map((tab) => {
                          const isActive = activeTab === tab.value;
                          const TabIcon = tab.icon;
                          return (
                            <Box
                              key={tab.value}
                              onClick={() => setActiveTab(tab.value)}
                              sx={{
                                flex: 1,
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                gap: "5px",
                                px: 1.5,
                                py: "7px",
                                borderRadius: "9px",
                                cursor: "pointer",
                                userSelect: "none",
                                transition: "all 0.18s ease",
                                background: isActive ? "#FFFFFF" : "transparent",
                                boxShadow: isActive
                                  ? "0 1px 4px rgba(15,23,42,0.10), 0 0 0 1px rgba(15,23,42,0.05)"
                                  : "none",
                                "&:hover": !isActive
                                  ? { background: "rgba(255,255,255,0.55)" }
                                  : {},
                              }}
                            >
                              <TabIcon
                                size={13}
                                color={isActive ? "#0D9488" : "#64748B"}
                                style={{ flexShrink: 0, transition: "color 0.15s" }}
                              />
                              <Typography
                                sx={{
                                  fontSize: "12.5px",
                                  fontWeight: isActive ? 700 : 500,
                                  color: isActive ? "#0D9488" : "#64748B",
                                  fontFamily: "'Inter', sans-serif",
                                  whiteSpace: "nowrap",
                                  transition: "color 0.15s",
                                }}
                              >
                                {tab.label}
                              </Typography>
                              {tab.count !== null && (
                                <Box
                                  sx={{
                                    minWidth: 18,
                                    height: 18,
                                    px: "5px",
                                    borderRadius: "6px",
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    background: isActive ? "#CCFBF1" : "#DDE3EC",
                                    transition: "background 0.18s",
                                  }}
                                >
                                  <Typography
                                    sx={{
                                      fontSize: "10.5px",
                                      fontWeight: 700,
                                      color: isActive ? "#0D9488" : "#64748B",
                                      lineHeight: 1,
                                      fontFamily: "'Inter', sans-serif",
                                    }}
                                  >
                                    {tab.count}
                                  </Typography>
                                </Box>
                              )}
                            </Box>
                          );
                        })}
                      </Box>
                    );
                  })()}


                  {/* Tab content */}
                  <Box sx={{ minHeight: 200 }}>
                    {activeTab === "comments" && (
                      <Comments
                        taskId={selectedData._id}
                        currentUserId={userId}
                        isAdmin={isAdmin}
                      />
                    )}

                    {activeTab === "worklog" && (
                      <WorkLogs
                        workLogsData={selectedData?.workLog || []}
                        selectedData={selectedData}
                        updateTaskData={updateTaskData}
                        isAdmin={isAdmin}
                      />
                    )}

                    {activeTab === "attachments" && (
                      <Attachments
                        files={selectedData?.file || []}
                        onAddFile={addFile}
                        onDeleteFile={handleDeleteFile}
                        loading={fileUploading}
                        taskId={selectedData?._id}
                        userId={userId}
                      />
                    )}

                    {activeTab === "activity" && (
                      <Activity key={activityRefreshKey} taskId={selectedData._id} isFromTemplate={selectedData?.isFromTemplate} />
                    )}

                    {activeTab === "recurring" && (
                      <RecurringSpawnsTab task={selectedData} />
                    )}
                  </Box>
                </Box>

                {/* ── Linked Testing Tasks ─────────────────────────────────── */}
                {selectedData?.issueType === ISSUETYPE.TESTING && (
                  <Box sx={{ mt: 3 }}>
                    <Stack
                      direction="row"
                      justifyContent="space-between"
                      alignItems="center"
                      mb={2}
                    >
                      <Typography
                        sx={{
                          fontSize: "16px",
                          color: "#181818",
                          fontWeight: 700,
                        }}
                      >
                        Linked Testing Tasks ({selectedData?.testingTasks?.length || 0})
                      </Typography>
                      <Button
                        variant="outlined"
                        size="small"
                        onClick={handleOpenLinkDialog}
                        sx={{
                          textTransform: 'none',
                          borderColor: '#008080',
                          color: '#008080',
                          '&:hover': {
                            borderColor: '#006666',
                            backgroundColor: '#F0FFFF'
                          }
                        }}
                      >
                        Link Tasks
                      </Button>
                    </Stack>

                    {selectedData?.testingTasks?.length > 0 ? (
                      <Stack spacing={1}>
                        {selectedData?.testingTasks?.map((tTask) => (
                          <Box
                            key={tTask._id}
                            sx={{
                              p: 2,
                              border: "1px solid #E0E0E0",
                              borderRadius: "8px",
                              cursor: "pointer",
                              "&:hover": {
                                backgroundColor: "#F5F5F5",
                              },
                            }}
                            onClick={() =>
                              navigate(
                                `/home/taskDetails?taskId=${tTask._id}`,
                                {
                                  state: {
                                    fromClient,
                                    filteredStatus,
                                    selectedMonth: filteredMonth,
                                    selectedYear: filteredYear,
                                  },
                                }
                              )
                            }
                          >
                            <Stack
                              direction="row"
                              alignItems="center"
                              spacing={1}
                              justifyContent="space-between"
                            >
                              <Stack direction="row" alignItems="center" spacing={1} sx={{ overflow: "hidden" }}>
                                <img
                                  src={Testing_Icon}
                                  alt="Testing"
                                  style={{ width: "20px", height: "20px" }}
                                />
                                <Typography
                                  sx={{
                                    fontWeight: 600,
                                    fontSize: "14px",
                                    color: "#181818",
                                  }}
                                >
                                  {tTask.taskNo}
                                </Typography>
                                <Typography
                                  sx={{
                                    fontSize: "14px",
                                    color: "#666",
                                    overflow: "hidden",
                                    textOverflow: "ellipsis",
                                    whiteSpace: "nowrap"
                                  }}
                                >
                                  {tTask.title}
                                </Typography>
                              </Stack>
                              {/* <Tooltip title="Unlink Task">
                                <IconButton size="small" onClick={(e) => handleUnlinkTask(tTask._id, e)}>
                                  <DeleteOutlineIcon fontSize="small" color="error" />
                                </IconButton>
                              </Tooltip> */}
                            </Stack>
                          </Box>
                        ))}
                      </Stack>
                    ) : (
                      <Typography
                        sx={{
                          fontSize: "14px",
                          color: "#999",
                          fontStyle: "italic",
                          textAlign: "center",
                          py: 2,
                        }}
                      >
                        No testing tasks linked to this task
                      </Typography>
                    )}
                  </Box>
                )}

                {/* Related to Task (Reverse Link) Section */}
                {selectedData?.parentTestingTaskDetails && (
                  <Box sx={{ mt: 3 }}>
                    <Typography
                      sx={{
                        fontSize: "16px",
                        color: "#181818",
                        fontWeight: 700,
                        mb: 2,
                      }}
                    >
                      Associated Testing Task
                    </Typography>
                    <Box
                      sx={{
                        p: 2,
                        border: "1px solid #E0E0E0",
                        borderRadius: "8px",
                        cursor: "pointer",
                        "&:hover": {
                          backgroundColor: "#F5F5F5",
                        },
                        borderLeft: "4px solid #008080",
                      }}
                      onClick={() =>
                        navigate(
                          `/home/taskDetails?taskId=${selectedData?.parentTestingTaskDetails?._id}`,
                          {
                            state: {
                              fromClient,
                              filteredStatus,
                              selectedMonth: filteredMonth,
                              selectedYear: filteredYear,
                            },
                          }
                        )
                      }
                    >
                      <Stack
                        direction="row"
                        alignItems="center"
                        spacing={1}
                      >
                        <Typography
                          sx={{
                            fontWeight: 600,
                            fontSize: "14px",
                            color: "#008080",
                          }}
                        >
                          View Testing Task
                        </Typography>
                        <Typography sx={{ fontWeight: 600, fontSize: "14px", color: "#181818", ml: 1 }}>
                          {selectedData?.parentTestingTaskDetails?.taskNo}
                        </Typography>
                        <Typography
                          sx={{
                            fontSize: "14px",
                            color: "#666",
                            flex: 1,
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            whiteSpace: "nowrap"
                          }}
                        >
                          {selectedData?.parentTestingTaskDetails?.title}
                        </Typography>
                      </Stack>
                    </Box>
                  </Box>
                )}


              </Box>
            ) : null}
          </Grid>



          {/* Desktop Sidebar (Collapsible Grid) */}
          {!isMobile && isDetailsOpen && (
            <Grid
              item
              md={4}
              sx={{
                padding: 1,
                paddingRight: 2,
                height: "100%",
                overflowY: "auto",
                overflowX: "hidden",
                borderLeft: "1px solid #e0e0e0",
                transition: "all 0.3s ease",
                flexShrink: 0,
                scrollbarWidth: "none",
                "&::-webkit-scrollbar": { display: "none" },
              }}
            >
              {selectedData?._id && !loading && (
                <>
                  <DetailsPanel
                    selectedData={selectedData}
                    fromClient={fromClient}

                    parentTasks={parentTasks}
                    isAdmin={isAdmin}
                    userId={userId}
                    onAssignedToChange={handleAssignedToChange}
                    onAssigneesChange={handleAssigneesChange}
                    onPrivateAssigneesChange={handlePrivateAssigneesChange}
                    onSupportChange={handleSupportChange}
                    onAcknowledgedByChange={handleAcknowledgedByChange}
                    onParentTaskChange={handleParentTaskChange}
                    onRemoveParentTask={handleRemoveParentTask}
                    onPriorityChange={handlePriorityChange}
                    onVerifyStatusChange={handleVerifyStatusChange}
                    onClientVerifyStatusChange={handleClientVerifyStatusChange}
                    onTypeChange={handletypeChange}
                    onStatusChange={handleStatusChange}
                    onClientChange={handleClientViewChange}
                    statusOption={filteredStatusOptions}
                    priorityOption={priorityOption}
                    typeOption={typeOption}
                    clientVerifyOption={clientVerifyOption}
                    QAVerifyOption={QAVerifyOption}
                    getCurrentStatusLabel={getCurrentStatusLabel}
                    getCurrentPriorityLabel={getCurrentPriorityLabel}
                    getCurrentIssueTypeLabel={getCurrentIssueTypeLabel}
                    getCurrentVerifyStatusLabel={getCurrentVerifyStatusLabel}
                    getParentTaskName={getParentTaskName}
                    onActualDeadlineDateChange={handleActualDeadlineDateChange}
                    onAllowDeadlineModificationChange={handleAllowDeadlineModificationChange}
                    onClientDeadlineDateChange={handleClientDeadlineDateChange}
                    onAcknowledge={handleAcknowledge}
                    onRequestRework={handleRequestRework}
                    onUpdate={updateTaskData}
                  />
                  <Box sx={{ mt: 2 }}>
                    <RecurringCard
                      selectedData={selectedData}
                      isAdmin={isAdmin}
                      onUpdate={updateTaskData}
                      onOpenTemplate={handleOpenTemplate}
                      onCreateTemplate={handleCreateTemplate}
                      accessDenied={templateAccessDenied}
                      onClearAccessDenied={() => setTemplateAccessDenied(false)}
                    />
                  </Box>
                </>
              )}
            </Grid>
          )}
        </Grid>

        {/* Mobile Sidebar (Drawer) */}
        <Drawer
          anchor="right"
          open={isMobile && isDetailsOpen}
          onClose={() => setIsDetailsOpen(false)}
          PaperProps={{
            sx: { width: "85%", padding: 2 }
          }}
        >
          <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", mb: 2 }}>
            <Typography variant="h6" fontWeight="bold">Task Details</Typography>
            <IconButton onClick={() => setIsDetailsOpen(false)}>
              <CloseIcon />
            </IconButton>
          </Box>
          {selectedData?._id && (
            <>
              <DetailsPanel
                selectedData={selectedData}
                fromClient={fromClient}
                parentTasks={parentTasks}
                isAdmin={isAdmin}
                userId={userId}
                onAssignedToChange={handleAssignedToChange}
                onAssigneesChange={handleAssigneesChange}
                onPrivateAssigneesChange={handlePrivateAssigneesChange}
                onAllowDeadlineModificationChange={handleAllowDeadlineModificationChange}
                onSupportChange={handleSupportChange}
                onAcknowledgedByChange={handleAcknowledgedByChange}
                onParentTaskChange={handleParentTaskChange}
                onRemoveParentTask={handleRemoveParentTask}
                onPriorityChange={handlePriorityChange}
                onVerifyStatusChange={handleVerifyStatusChange}
                onClientVerifyStatusChange={handleClientVerifyStatusChange}
                onTypeChange={handletypeChange}
                onStatusChange={handleStatusChange}
                onClientChange={handleClientViewChange}
                statusOption={filteredStatusOptions}
                priorityOption={priorityOption}
                typeOption={typeOption}
                clientVerifyOption={clientVerifyOption}
                QAVerifyOption={QAVerifyOption}
                getCurrentStatusLabel={getCurrentStatusLabel}
                getCurrentPriorityLabel={getCurrentPriorityLabel}
                onAcknowledge={handleAcknowledge}
                onRequestRework={handleRequestRework}
                getCurrentIssueTypeLabel={getCurrentIssueTypeLabel}
                getCurrentVerifyStatusLabel={getCurrentVerifyStatusLabel}
                getParentTaskName={getParentTaskName}
                onActualDeadlineDateChange={handleActualDeadlineDateChange}
                onClientDeadlineDateChange={handleClientDeadlineDateChange}
                onUpdate={updateTaskData}
              />
              <Box sx={{ mt: 2 }}>
                <RecurringCard
                  selectedData={selectedData}
                  isAdmin={isAdmin}
                  onUpdate={updateTaskData}
                />
              </Box>
            </>
          )}
        </Drawer>
      </Box>

      {/* Recurring Template Editor Drawer */}
      <Drawer
        anchor="right"
        open={templateDrawerOpen}
        onClose={() => { setTemplateDrawerOpen(false); setTemplateDrawerData(null); setTemplatePrefill(null); }}
        PaperProps={{
          sx: {
            width: { xs: "100vw", sm: 580 },
            bgcolor: "#F1F5F9",
            boxShadow: "-8px 0 40px rgba(0,0,0,0.14)",
            borderLeft: "1px solid #E2E8F0",
          },
        }}
      >
        <RecurringTemplateMain
          initialTemplate={templateDrawerData || undefined}
          initialView={templateDrawerData ? "edit" : "create"}
          prefillData={templateDrawerData ? null : templatePrefill}
          onClose={() => { setTemplateDrawerOpen(false); setTemplateDrawerData(null); setTemplatePrefill(null); }}
        />
      </Drawer>

      {/* Linked Testing Tasks Dialog */}
      <Dialog
        open={openLinkDialog}
        onClose={handleCloseLinkDialog}
        maxWidth="md"
        fullWidth
      >
        <DialogTitle sx={{ borderBottom: '1px solid #eee', pb: 1 }}>
          Link Testing Tasks
        </DialogTitle>
        <DialogContent sx={{ pt: 2, height: '400px', overflowY: 'auto' }}>
          {isFetchingTasks ? (
            <Stack alignItems="center" justifyContent="center" height="100%">
              <Typography>Loading tasks...</Typography>
            </Stack>
          ) : testingTasksList.length === 0 ? (
            <Stack alignItems="center" justifyContent="center" height="100%">
              <Typography>No other testing tasks found.</Typography>
            </Stack>
          ) : (
            <Stack spacing={1} sx={{ mt: 1 }}>
              {testingTasksList.map(task => (
                <Box
                  key={task._id}
                  sx={{
                    p: 1,
                    border: '1px solid #eee',
                    borderRadius: 1,
                    display: 'flex',
                    alignItems: 'center',
                    gap: 2,
                    '&:hover': { bgcolor: '#FAFAFA' }
                  }}
                >
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={selectedLinkIds.includes(task._id)}
                        onChange={() => handleToggleTaskSelection(task._id)}
                        color="primary"
                      />
                    }
                    label=""
                    sx={{ m: 0 }}
                  />
                  <Stack flex={1}>
                    <Stack direction="row" justifyContent="space-between">
                      <Typography variant="subtitle2" fontWeight="600">
                        {task.taskNo}
                      </Typography>
                      <Typography variant="caption" sx={{
                        bgcolor: '#e3f2fd',
                        color: '#1976d2',
                        px: 1,
                        borderRadius: 1
                      }}>
                        {getStatusLabel(task.status)}
                      </Typography>
                    </Stack>
                    <Typography variant="body2" noWrap sx={{ maxWidth: '400px' }}>
                      {task.title}
                    </Typography>
                  </Stack>
                  <Avatar
                    sx={{ width: 24, height: 24, fontSize: 10 }}
                    src={task?.assignee_info?.file?.location}
                  >
                    {task?.assignee_info?.firstName?.[0] || "?"}
                  </Avatar>
                </Box>
              ))}
            </Stack>
          )}
        </DialogContent>
        <DialogActions sx={{ borderTop: '1px solid #eee', p: 2 }}>
          <Button onClick={handleCloseLinkDialog} color="inherit">Cancel</Button>
          <Button onClick={handleSaveLinks} variant="contained" color="primary">
            Save & Link
          </Button>
        </DialogActions>
      </Dialog>

      {/* ── Archive / Delete / Restore confirm ──────────────────────────────── */}
      <Dialog
        open={lifecycleDialog.open}
        onClose={closeLifecycleDialog}
        maxWidth="xs"
        fullWidth
      >
        <DialogTitle sx={{ fontSize: "15px", fontWeight: 700, pb: 1 }}>Confirm</DialogTitle>
        <DialogContent>
          <Typography sx={{ fontSize: "14px", color: "#475569" }}>{lifecycleDialog.message}</Typography>
        </DialogContent>
        <DialogActions sx={{ px: 2.5, pb: 2 }}>
          <Button onClick={closeLifecycleDialog} sx={{ textTransform: "none", color: "#64748B" }}>
            Cancel
          </Button>
          <Button
            variant="contained"
            disabled={lifecycleBusy}
            onClick={() => {
              const run = lifecycleDialog.onConfirm;
              closeLifecycleDialog();
              run?.();
            }}
            sx={
              lifecycleDialog.danger
                ? { textTransform: "none", bgcolor: "#DC2626", "&:hover": { bgcolor: "#B91C1C" } }
                : { textTransform: "none", bgcolor: "#0D9488", "&:hover": { bgcolor: "#0F766E" } }
            }
          >
            {lifecycleDialog.confirmLabel}
          </Button>
        </DialogActions>
      </Dialog>
    </div >
  );
};

export default TaskDetails;
